// =============================================================================
//  Copyright   : 2020 semantics GmbH
//  Date        : $Date: 2024-04-23 00:07:12 +0200 (Tue, 23 Apr 2024) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 142322 $
//  Purpose     : custom column definitions for fulltext package
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {dict} from 'ldash'
import {registerColumnTypes, ColumnTypeNames as $} from 'uix/db/columnTypes'
import log from 'uix/logging'

// ---Local imports
import {useOcrConfig} from './hooks'

// ---Globals
const OcrConfig = ({coid}) => {
  let ocr_cfg = useOcrConfig()
  if (!ocr_cfg) {
    return null
  }

  if (ocr_cfg[coid]) {
    let {language, textType} = ocr_cfg[coid]
    return `${language.join(', ')} / ${textType.join(', ')}`
  } else if (coid === null) {
    return null
  }
  return `${coid}`
}

registerColumnTypes({
  OcrConfigColumn: (env, colid, options) => ({
    Cell: ({value}) => (value ? <OcrConfig coid={value} /> : null),
    aggregate: vals => '',
  }),
})

export const columns = [
  // OCR - Config
  [$.OcrConfigColumn, 'co.id'],

  // OCR - Pages
  /*
  [
    $.TextColumn,
    'oo.type',
    {
      i18nKey: 'OCR Typ',
      groupBySupport: true,
      translate: v =>
        v > 0 ? {1: 'FineReader', 2: 'FineReader (man)', 3: 'FineReader (imp)'}[v] : null,
    },
  ],

  [$.PercentageColumn, 'oo.charconfidence', {i18nKey: 'OCR Qualität (C)'}],
  [$.PercentageColumn, 'oo.wordpenalty', {i18nKey: 'OCR Qualität (W)', inverted: true}],

  [
    $.BooleanColumn,
    'oo.checklanguage',

    {
      i18nKey: 'OCR Sprache prüfen',
      trueVal: 1,
      icon: 'exclamation triangle',
    },
  ],
  [
    $.BooleanColumn,
    'oo.checkresolution',
    {
      i18nKey: 'OCR Auflösung prüfen',
      trueVal: 1,
      icon: 'exclamation triangle',
    },
  ],

  [$.NumberColumn, 'oo.wordcount', {i18nKey: 'OCR Wörter'}],
  [$.NumberColumn, 'oo.licencecount', {i18nKey: 'OCR Antiqua'}],
  [$.NumberColumn, 'oo.licencegothic', {i18nKey: 'OCR Fraktur'}],
  [
    $.NumberColumn,
    'oo.skewangle',
    {
      i18nKey: 'OCR Drehung',
      transform: v => (v ? (v * (180 / Math.PI)).toFixed(1) : undefined),
    },
  ],

  [$.DateColumn, 'oo.insertts', {i18nKey: 'OCR Datum'}],
  */

  [$.CustomBooleanColumn, 'oor.exists', {fields: ['oor.id']}],
  [$.PercentageColumn, 'oor.correctionratio', {inverted: true, factor: 100}],
  [$.PercentageColumn, 'oor.correctionratiobagged', {inverted: true, factor: 100}],
  [$.PercentageColumn, 'oor.charconf'],
  ...['word', 'line', 'para', 'block'].map(n => [$.NumberColumn, `oor.${n}count`, {}]),

  // OCR - Metadata
  //~ [$.PercentageColumn, 'oo_md.charconfidence', {i18nKey: 'OCR Qualität (C)'}],
  //~ [$.NumberColumn, 'oo_md.licencecount', {i18nKey: 'OCR Antiqua'}],
  //~ [$.NumberColumn, 'oo_md.licencegothic', {i18nKey: 'OCR Fraktur'}],
  //~ [$.NumberColumn, 'oo_md.checklanguage', {i18nKey: 'Sprache prüfen'}],
  //~ [$.NumberColumn, 'oo_md.checkresolution', {i18nKey: 'OCR Auflösung prüfen'}],
  //~ [$.NumberColumn, 'oo_md.pagecount', {i18nKey: 'OCR Seiten'}],
  //~ [$.DateColumn, 'oo_md.insertts', {i18nKey: 'OCR Datum'}],
]
